import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.COLORS.SUB_BACKGROUND};
  padding-block: 50px;

   @media (max-width: 768px) {
         height: 100vh;
    }
`;
export const SubContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 35px;
  margin-left: 10px;
  font-weight: 700;
  text-align: center;
  margin: 0;
  padding: 10px;

      @media (max-width: 360px) {
       font-size: 17px;
    }
      @media (max-width: 768px) {
       font-size: 25px;
    }
`;
export const Description = styled.h2`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-weight: 500;
  font-size: 17px;
  margin: 0;
  text-align: center;

  @media (max-width: 360px) {
       font-size: 13px;
    }
     @media (max-width: 768px) {
       font-size: 15px;
    }
`;
export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-top: 30px;
`;
export const SubContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  padding-top: 30px;
`;
export const ContentPremium = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

     @media (max-width: 360px) {
  justify-content: space-between;
    }
     @media (max-width: 768px) {
  justify-content: center;
    }
`;
export const ContainerCard = styled.div`
  width: 200px;
  height: 150px;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.COLORS.SECONDARY};
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.COLORS.PRIMARY};

  @media (max-width: 360px) {
  width: 130px;
    }
  @media (max-width: 768px) {
  width: 40%;
  height: 200px;
    }
`;
export const TitlePremium = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 20px;
  font-weight: 700;
  padding: 0;
  margin: 0;

    @media (max-width: 360px) {
       font-size: 13px;
    }
     @media (max-width: 768px) {
       font-size: 15px;
    }
`;
export const DescriptionPremium = styled.h2`
  color: ${({ theme }) => theme.COLORS.DESCRIPTION};
  font-size: 15px;
  font-weight: 500;
  padding: 0;
  margin: 0;

    @media (max-width: 360px) {
       font-size: 13px;
    }
     @media (max-width: 768px) {
       font-size: 15px;
    }
`;
export const Image = styled.img`
  width: 40px;
  height: 40px;
`;
export const SliderImage = styled.img`
    width: 80%;
    height: auto;
`;
export const ImageApp = styled.img`
    width: 90%;
    height: auto;
`;
export const SubContentTestimonial = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

       @media (max-width: 360px) {
  flex-direction: column;
    }
     @media (max-width: 768px) {
  flex-direction: column;
    }
`;
export const TestimonialImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 10px
`;
export const ContentTestimonial = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 10px;
  padding: 10px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.COLORS.SECONDARY};
`;
export const ContainerSave = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  /* border: 1px solid red; */

       @media (max-width: 360px) {
  flex-direction: column;
    }
     @media (max-width: 768px) {
  flex-direction: column;
    }
`;
export const ContainerSaveLeft = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;
export const ContainerSaveRight = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND_BUTTON};
  border-radius: 10px;

`;